"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ExternalLinkRenderer = {
    renderV1(link) {
        const target = typeof link.target === "string" ? { target: link.target } : {};
        return {
            type: "Link.web",
            value: {
                url: link.url,
                ...target,
            },
        };
    },
    renderV2(_def, link) {
        const partialRender = {
            link_type: "Web",
            url: link.url,
        };
        return Object.assign(partialRender, typeof link.target === "string" ? { target: link.target } : {});
    },
    renderMocks(def, link) {
        return this.renderV2(def, link);
    },
};
exports.default = ExternalLinkRenderer;
